module.exports = __webpack_public_path__ + "img/facilityInfo_3_8.3b5c7c48.jpg";